'use client';

import { useQuery } from '@zg-rentals/react-query5';
import { type ExtendedListing, fetchProviderListingsPortfolio } from '@/src/lib/api/endpoints/listing';

export const providerListingsKeys = {
  all: ['halo', 'providerListings'] as const,
  byAlias: (aliasEncoded: string | null) => ['halo', 'providerListings', 'byAlias', aliasEncoded ?? ''] as const,
};

export function useProviderListings(aliasEncoded: string | null | undefined, { enabled }: { enabled: boolean }) {
  return useQuery<Array<ExtendedListing>>({
    queryKey: providerListingsKeys.byAlias(aliasEncoded ?? null),
    queryFn: async () => {
      if (!aliasEncoded) return [];
      return fetchProviderListingsPortfolio(aliasEncoded);
    },
    enabled: Boolean(aliasEncoded) && enabled,
    staleTime: 5 * 60 * 1000,
    meta: {
      tags: ['provider-listings'],
      context: {
        api: 'hotpads-api',
        details: 'HDP provider listings portfolio',
      },
    },
  });
}
